import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { MdOnDeviceTraining, MdOutlineVerified, MdPlayCircleOutline } from "react-icons/md";
import { FaHandPointRight, FaRegCheckCircle, FaRegClock, FaUserTie } from "react-icons/fa";
import { TbArrowBigDownLinesFilled, TbCertificate } from "react-icons/tb";
import { BiSolidDiscount } from "react-icons/bi";
import { useParams } from 'react-router-dom';
import Footer from '../../components/Footer';
import { initFacebookPixel } from '../../pixel';
import { config } from '../../config';
import { motion, AnimatePresence } from 'framer-motion';
import { WebinarContext } from './context/WebinarContext';
import UserAttendees from './Components/LandingPage/UserAttendees';
import Secrets from './Components/LandingPage/Secrets';
import Instractors from './Components/LandingPage/Instractors';
import VideoPreview from './Components/LandingPage/VideoPreview';
import RegistrationCard from './Components/LandingPage/RegistrationCard';
import Testimonials from './Components/LandingPage/Testimonials';
import Faq from './Components/LandingPage/Faq';
import Cta from './Components/LandingPage/Cta';
import RegistrationForm from './Components/LandingPage/RegistrationForm/RegistrationForm';
import { PixelContext } from '../Context/PixelContext';

const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const WebinarHome = () => {
  const [timer, setTimer] = useState('');
  const [nextSession, setNextSession] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [registeredCount, setRegisteredCount] = useState(75);
  const [attendees, setAttendees] = useState([]);
  const [bonuses, setBonuses] = useState([]);
  const [leads, setLeads] = useState([]);
  const [secrets, setSecrets] = useState([]);
  const [instructors, setInstructors] = useState([]);
  const [socialproofs, setSocialproofs] = useState([]);
  const [ctas, setCtas] = useState([]);
  const [faqs, setFaqs] = useState([]);


// ডিফল্ট কালার সেট (WebinarHome কম্পোনেন্টের শুরুতে)
const [gradientClass, setGradientClass] = useState('bg-gradient-to-r from-blue-600 to-indigo-700');
const [bgColor, setBgColor] = useState('bg-blue-600');
const [bgShadow, setBgShadow] = useState('bg-blue-50');
const [ctaColor, setCtaColor] = useState('bg-gradient-to-r from-blue-500 to-purple-500');
const [textColor, setTextColor] = useState('text-blue-600');
const [textShadow, setTextShadow] = useState('text-blue-100');
const [hoverColor, setHoverColor] = useState('bg-blue-700');

  const {
    loading,
    error,
    imageUrl,
    slug,
    landingPage
  } = useContext(WebinarContext);

  const { pixel } = useContext(PixelContext);
  const pixelId = pixel?.pixel_id || null;

  console.log('Landing Page Data:', landingPage);

  // Make sure pixel is set from landingPage data
  useEffect(() => {
    setAttendees(landingPage?.attendees?.[0] || []);
    setBonuses(landingPage?.bonuses?.[0] || []);
    setLeads(landingPage?.leads?.[0] || []);
    setSecrets(landingPage.secrets?.[0] || []);
    setInstructors(landingPage.webinarinstructors || []);
    setSocialproofs(landingPage.socialproofs || []);
    setCtas(landingPage?.ctas?.[0] || []);
    setFaqs(landingPage.faqs || []);
  }, [landingPage]);



  useEffect(() => {
    // Simulate live registration count
    const interval = setInterval(() => {
      setRegisteredCount(prev => {
        const randomIncrement = Math.floor(Math.random() * 3) + 1;
        return prev + randomIncrement;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (pixelId) {
      initFacebookPixel(pixelId);
    }
  }, [pixelId]);

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      if (!landingPage.startsIn) {
        return;
      }
      const startsIn = Number(landingPage.startsIn);

      localStorage.setItem('time', startsIn);

      const nextWebinar = new Date(now.getTime());
      nextWebinar.setMinutes(Math.ceil(nextWebinar.getMinutes() / startsIn) * startsIn, 0, 0);
  
      const diff = Math.max(0, nextWebinar - now);
      const minutes = Math.floor(diff / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
      const hours = Math.floor(minutes / 60);
      const remMinutes = minutes % 60;
  
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = remMinutes.toString().padStart(2, '0');
      const formattedSeconds = seconds.toString().padStart(2, '0');
  
      let sessionHour = nextWebinar.getHours();
      const sessionMinute = nextWebinar.getMinutes().toString().padStart(2, '0');
      const sessionPeriod = sessionHour >= 12 ? 'PM' : 'AM';
      sessionHour = sessionHour % 12 || 12;
  
      setTimer(`${formattedHours} hr ${formattedMinutes} min ${formattedSeconds} sec`);
      setNextSession(`${sessionHour}:${sessionMinute} ${sessionPeriod}`);
    };
  
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, [landingPage.startsIn]);
  
  const handleShowForm = () => setShowForm(true);
  const handleCloseForm = () => setShowForm(false);

  if (loading) return (
    <div className="flex justify-center items-center h-screen bg-gradient-to-br from-purple-50 to-indigo-50">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-purple-500 mb-4"></div>
        <p className={`${textColor} font-medium`}>Loading your exclusive MasterClass access...</p>
      </div>
    </div>
  );
  
  if (error) return (
    <div className="flex justify-center items-center h-screen bg-gradient-to-br from-purple-50 to-indigo-50">
      <div className="text-center p-8 bg-white rounded-lg shadow-xl max-w-md">
        <div className="text-red-500 text-4xl mb-4">⚠️</div>
        <h3 className="text-2xl font-bold text-gray-800 mb-2">Oops! Something went wrong</h3>
        <p className="text-gray-600 mb-6">{error}</p>
        <button 
          onClick={() => window.location.reload()} 
          className={`${bgColor} text-white px-6 py-2 rounded-lg hover:${hoverColor} transition-colors`}
        >
          Try Again
        </button>
      </div>
    </div>
  );

  return (
    <div className="relative min-h-screen flex flex-col justify-between bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Animated Top Banner */}
      <motion.div 
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className={`flex justify-center items-center p-3 ${gradientClass} text-white shadow-lg`}
      >
        <div className="flex items-center justify-center text-center md:text-start animate-pulse">
          <MdOutlineVerified className="mr-2 text-xl" />
          <span className='font-medium'>
            {landingPage.topBar || "Limited-time offer: Register now and get exclusive bonuses!"}
          </span>
        </div>
      </motion.div>

      {/* Main Content */}
      <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="flex flex-col items-center text-center mb-12"
        >
          {/* <motion.div
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
            className={`mb-6 px-4 py-2 ${bgShadow} ${textColor} rounded-full inline-flex items-center`}
          >
            <BiSolidDiscount className="mr-2" />
            <span className="font-semibold">Special Offer for Early Registrants</span>
          </motion.div> */}

          <motion.h1 
            className="text-3xl lg:text-6xl font-extrabold text-gray-900 mb-4 leading-tight"
            initial={{ opacity: 0, y: -20 }}
            animate={{ 
              opacity: 1, 
              y: 0,
              textShadow: gradientClass
            }}
            transition={{ 
              duration: 1.5,
              repeat: 2,
              repeatType: "reverse"
            }}
          >
            <span className={`bg-clip-text text-2xl md:text-6xl text-transparent leading-relaxed md:leading-snug ${gradientClass}`}>
              {landingPage.headline || "Master Digital Marketing in 2024"}
            </span>
          </motion.h1>

          <h3 className="text-lg lg:text-2xl text-gray-700 mb-6 font-medium max-w-3xl">
            {landingPage.subHeadline || "The proven system that helped 5,000+ students grow their businesses online"}
          </h3>

          <UserAttendees attendees={attendees} />

          <motion.div 
            whileHover={{ scale: 1.01 }}
            className="bg-white p-6 rounded-xl shadow-lg mb-8 w-full max-w-2xl"
          >
            <div className="flex items-start">
              {/* <FaRegClock className={`${textColor} text-2xl mt-1 mr-4 flex-shrink-0 `}/> */}
              <div>
                <p className="text-lg text-gray-600">
                  {landingPage.paragraph || "In this exclusive training, you'll discover the exact strategies we've used to generate over $2M in online revenue for our clients. This is NOT theory - you'll get actionable steps you can implement immediately."}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.button
            onClick={handleShowForm}
            whileHover={{ scale: 1.02, boxShadow: "0 10px 25px -5px rgba(124, 58, 237, 0.4)" }}
            whileTap={{ scale: 0.98 }}
            className={`${gradientClass} text-white py-4 px-8 rounded-lg text-lg font-bold flex items-center`}
          >
            <MdPlayCircleOutline className="mr-2 text-xl" />
            Watch Free Training Now
          </motion.button>
        </motion.div>

        {/* Main Content Grid */}
        <div className="flex flex-col lg:flex-row gap-8 justify-center items-start">
          {/* Left Column */}
          <div className="w-full lg:w-1/2 space-y-8">
            {landingPage && <VideoPreview landingPage={landingPage} imageUrl={imageUrl} handleShowForm={handleShowForm} bgColor={bgColor} hoverColor={hoverColor} textColor={textColor} />}
            {secrets && <Secrets secrets={secrets} textColor={textColor} textShadow={textShadow} />}
            {instructors.length > 0 && <Instractors instructors={instructors} imageUrl={imageUrl} gradientClass={gradientClass} />}
          </div>

          {/* Right Column - Registration Card */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="w-full lg:w-1/2 sticky top-4"
          >
            <RegistrationCard 
              landingPage={landingPage} 
              bonuses={bonuses}
              handleShowForm={handleShowForm} 
              registeredCount={registeredCount} 
              timer={timer}
              nextSession={nextSession}
              gradientClass={gradientClass}
              bgColor={bgColor}
              textColor={textColor}
              bgShadow={bgShadow}
              textShadow={textShadow}
            />

            {/* Mobile Testimonials (only shown on mobile) */}
            {socialproofs.length > 0 && <Testimonials socialproofs={socialproofs} imageUrl={imageUrl} variant="mobile" className="lg:hidden mt-8" />}
          </motion.div>
        </div>

        {/* Desktop Testimonials (only shown on desktop) */}
        {socialproofs.length > 0 && <Testimonials socialproofs={socialproofs} imageUrl={imageUrl} variant="desktop" className="hidden lg:block mt-16" />}

        {/* FAQ Section */}
        {faqs.length > 0 && <Faq faqs={faqs} />}

        {/* Final CTA */}
       { ctas.length > 0 &&
        <Cta 
          ctas={ctas}
          handleShowForm={handleShowForm}
          gradientClass={gradientClass}
          textColor={textColor}
          textShadow={textShadow}
         />}
      </div>

      {/* Footer Section */}
      <Footer footerText={landingPage.footerText || "© 2024 Digital Marketing Mastery. All rights reserved."} />

      {/* Registration Form Modal */}
      <AnimatePresence>
        {showForm && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 overflow-y-auto"
          >
            <RegistrationForm leads={leads} slug={slug} handleCloseForm={handleCloseForm} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default WebinarHome;